const SUBSIDY_EVENTS = Object.freeze({
  ADD: 'Add',
  REMOVE: 'Remove',
});

export { SUBSIDY_EVENTS };
